// @flow

export function userBrazilianCpfErrorMessage(error: ?string): ?string {
  if (error === 'empty') {
    return 'Preencha o número do seu CPF';
  }

  if (error === 'invalid') {
    return 'Documento inválido';
  }

  return error;
}

export function cardHolderNameErrorMessage(error: ?string): ?string {
  if (error === 'empty' || error === 'invalid') {
    return 'Preencha com o nome que aparece em seu cartão';
  }

  return error;
}

export function cardNumberErrorMessage(error: ?string): ?string {
  if (error === 'empty' || error === 'invalid') {
    return 'Informe o número do cartão';
  }

  return error;
}

export function cardDueDateErrorMessage(error: ?string): ?string {
  if (error === 'empty' || error === 'invalid') {
    return 'Por favor, insira a validade do cartão';
  }

  if (error === 'expired') {
    return 'Ops! O cartão informado está vencido';
  }

  return error;
}

export function cardCvvErrorMessage(error: ?string): ?string {
  if (error === 'empty') {
    return 'Preencha o código de segurança do cartão';
  }

  return error;
}
